import {Component, OnDestroy, OnInit} from '@angular/core';
import {CommonModule} from '@angular/common';
import {FormsModule} from '@angular/forms';
import {NgSelectComponent} from '@ng-select/ng-select';
import {Subscription} from 'rxjs';
import {IYii} from '../../../globals';
import {AssignmentService} from '../services/AssignmentService';
import {ProgressBar} from 'primeng/progressbar';
import {Checkbox} from 'primeng/checkbox';
import {ILoadedPositions, PositionsService} from '../services/PositionsService';
import {IGQLUserPosition} from '@betterchains/bc-gql';
import {SystemService} from '../services/SystemService';

declare var Yii: IYii;

@Component({
  selector: 'ng-assignments-positions',
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    NgSelectComponent,
    ProgressBar,
    Checkbox
  ],
  templateUrl: './assignments-positions.html',
})
export class AssignmentsPositions implements OnInit, OnDestroy {
  public Yii = Yii;
  private subs: Subscription[] = [];

  public data: ILoadedPositions = {
    positions: [],
    view_positions: [],
    additional: {
      additional_info: "",
      branch_id: 0,
      chain_id: 0,
      form_id: 0,
      id: 0,
      show_in_target_branch: 0
    }
  }

  public positions: IGQLUserPosition[] = []

  public show_in_target_branch = false;

  constructor(
    public asvc: AssignmentService,
    public posvc: PositionsService,
    private sysvc: SystemService,
  ) {
  }

  load() {
    this.sysvc.GetPositions(this.asvc.GetCurrentChainId()).then(positions => this.positions = positions)
    this.posvc.Load().then(data => {
        this.data = data;
        this.show_in_target_branch = data.additional.show_in_target_branch == 1;
      })
  }

  ngOnInit(): void {
    this.subs.push(this.asvc.OnChainChanged.subscribe({next: () => this.load()}))
    this.subs.push(this.asvc.OnBranchChanged.subscribe({next: () => this.load()}))
    this.load();
  }

  ngOnDestroy(): void {
    this.subs.forEach(sub => sub.unsubscribe());
  }

  sync() {
    this.data.additional.show_in_target_branch = this.show_in_target_branch ? 1 : 0;
    this.posvc.Sync(this.data)
  }
}
